import { Grid } from '@hermes/web-components'
import { StyledNumberSearch } from './styles'

const TrustRatingStatisticSearch = ({ count, name }: { count?: number; name?: string }) => (
  <Grid item container alignItems="center" sm>
    {count !== undefined && (
      <StyledNumberSearch>
        ({count} {name})
      </StyledNumberSearch>
    )}
  </Grid>
)

export default TrustRatingStatisticSearch
